var XPortal = XPortal || {};
XPortal.Hidden =
{
    ControlSelector: ".xpand-hidden",
    ControlSelectorNotInFSet: ".xpand-hidden:not(.dynamic-filter-set .xpand-hidden)",
    Init: function (container, exceptFSets) {
        const self = this;
        container = container ? container : $(XPortal.Main.DetialFormSelector);
        container.find(exceptFSets ? self.ControlSelectorNotInFSet : self.ControlSelector).each(function () {
            self.initFor(XPortal.Store.getModelName(container[0].id), this);
        });
    },
    initFor: function (modelName, domEl) {
        const el = $(domEl);
        const sttgs = XPortal.Main.GetSettingsFor(el);
        const mval = sttgs.ismultiselect && sttgs.value && sttgs.value.length ? sttgs.value.split(sttgs.valueSeparator) : sttgs.value;

        if (mval) {
            XPortal.Store.DispatchByName(modelName, sttgs.fieldname, mval);
        }
        XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el },
            (value) => !XPortal.DefaultEditor.IsModified(el) ? el.val(value) : false,
            (value) => el ? el.val() : false
        );
    }
};